import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=09c51da9&scoped=true"
import script from "./Advantages.vue?vue&type=script&lang=js"
export * from "./Advantages.vue?vue&type=script&lang=js"
import style0 from "./Advantages.vue?vue&type=style&index=0&id=09c51da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c51da9",
  null
  
)

export default component.exports